





























import {Vue, Component} from 'vue-property-decorator';
import RadioElement from '@/components/common/RadioElement.vue';

import {addClass, removeClass} from '@/utils/classUtils';
import {popupResize} from '@/utils/ncp';
@Component({
  components: {RadioElement}
})
export default class ChangeBestReview extends Vue {
  private reviewNos: any = [];

  // 상품평 구분 변경
  private reviewType = 'N';
  private reviewTypes = {
    name: 'reviewTypes',
    data: [
      {
        id: 'reviewTypes_NORMAL',
        value: 'N',
        dispaly: 'PRODUCT_REVIEW_REVIEW_TYPE_NORMAL'
      },
      {
        id: 'reviewTypes_BEST',
        value: 'Y',
        dispaly: 'PRODUCT_REVIEW_REVIEW_TYPE_BEST'
      }
    ]
  };

  // 확인
  private async confirm() {
    let request = {
      data: {
        reviewNos: this.reviewNos,
        bestReviewYn: this.reviewType
      }
    };
    let {data} = await this.$api.putReviewsBestReview(request);
    let callBack = sessionStorage.getItem('callBack');
    if (callBack) {
      $(window.opener.location).attr('href', `javascript:window.${callBack}(${JSON.stringify(data)});`);
    }
    this.cancel();
  }
  // 취소
  private cancel() {
    window.close();
  }

  private mounted() {
    this.reviewNos = JSON.parse(sessionStorage.getItem('reviewNos'));
    addClass(document.body, 'popup_small');
    addClass(document.getElementById('content'), 'review_change');
    this.$nextTick(() => {
      popupResize();
    });
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_small');
    removeClass(document.getElementById('content'), 'review_change');
  }
}
